import React from "react";

interface IProps {
  title: string;
  extra?: React.ReactNode;
  children: React.ReactNode;
}

/** One titled block of the doctor profile. */
export default function SectionCard({ title, extra, children }: IProps) {
  return (
    <section className="flex flex-col gap-3 p-4 lg:p-6 rounded-2xl border border-common-divider bg-common-white">
      <div className="flex justify-between items-center gap-4">
        <h2 className="m-0 text-base lg:text-lg font-semibold font-['Inter'] text-common-maintext">{title}</h2>
        {extra}
      </div>

      {children}
    </section>
  );
}
